import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ListingSummaryResolver } from "./listing/listing-summary.resolver";
import { PermissionListGuard } from "./permission-list.guard";
import { SupportedBrowserGuard } from "./supported-browser.guard";
import { AuthCallbackComponent } from "src/auth-callback.component";
import { AuthGuard } from "./auth.guard";
import { LogoutComponent } from "../logout.component";

const routes: Routes = [
	{ path: "error", loadChildren: () => import("./error/error.module").then((m) => m.ErrorModule) },
	{ path: "polaris", redirectTo: "" },
	{
		path: "",
		canActivate: [SupportedBrowserGuard, AuthGuard],
		children: [
			{ path: "auth-callback", component: AuthCallbackComponent },
			{
				path: "home",
				redirectTo: "",
			},
			{
				path: "logout",
				component: LogoutComponent,
			},
			{
				path: "",
				canActivate: [AuthGuard],
				loadChildren: () => import("./home/home.module").then((m) => m.HomeModule),
			},
			{
				path: "listing/new",
				canActivate: [PermissionListGuard, AuthGuard],
				data: {
					excludePermissionLevels: ["agent-subscriber"],
				},
				loadChildren: () => import("./autopop/autopop.module").then((m) => m.AutopopModule),
			},
			{
				path: "listing/:mlid",
				runGuardsAndResolvers: "always",
				resolve: {
					listingSummary: ListingSummaryResolver,
				},
				canActivate: [AuthGuard],
				loadChildren: () => import("./listing/listing.module").then((l) => l.ListingModule),
			},
			{
				path: "preferences",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./preferences/preferences.module").then((m) => m.PreferencesModule),
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
